import { render, staticRenderFns } from "./annualReportList.vue?vue&type=template&id=72507b85&scoped=true"
import script from "./annualReportList.vue?vue&type=script&lang=js"
export * from "./annualReportList.vue?vue&type=script&lang=js"
import style0 from "./annualReportList.vue?vue&type=style&index=0&id=72507b85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72507b85",
  null
  
)

export default component.exports